import { ChevronRightIcon } from '@chakra-ui/icons'
import { Box, Button, ButtonProps, HStack } from '@chakra-ui/react'

import Link from 'next/link'

const BuyButton = ({ ...props }: ButtonProps) => {
  return (
    <Link href="/products/arctic-grip-tumbler" style={{ display: 'contents' }}>
      <Button
        fontFamily="Inter"
        variant="ghost"
        textTransform="uppercase"
        fontWeight={500}
        background="white"
        color="#ADBDB0"
        border="4px solid #ADBDB0"
        borderRadius={40}
        fontSize={{
          base: 16,
          sm: 18,
          md: 20,
          lg: 24,
          '2xl': 28
        }}
        mt={2}
        ml={{
          base: 0,
          sm: '74px',
          md: 24,
          lg: 10
        }}
        pl={{
          base: 4,
          lg: 6
        }}
        pr={0}
        py={{
          base: 2,
          sm: 5,
          md: 5,
          lg: 6,
          xl: 7
        }}
        display="flex"
        alignItems="center"
        {...props}
      >
        <HStack gap={0} justifyContent={'center'}>
          <Box>Buy Now</Box>
          <ChevronRightIcon
            w={{
              base: 6,
              sm: 7,
              md: 8,
              lg: 9,
              xl: 10
            }}
            h={{
              base: 6,
              sm: 7,
              md: 8,
              lg: 9,
              xl: 10
            }}
          />
        </HStack>
      </Button>
    </Link>
  )
}

export default BuyButton
